import React from 'react';
import { useDossierContext } from './dossier.context';
import { useConfigurationContext } from 'common-app/configuration/configuration.context';
export const DossierInfo = () => {
    const { dossier } = useDossierContext();
    const { configuration } = useConfigurationContext();
    const { dateLimit } = configuration || {};
    return (React.createElement("div", { className: 'reference bg-primary top-0 end-0 p-3 fw-500' },
        dossier && React.createElement("p", { className: 'font-size-12 text-white mb-1' },
            "Vos r\u00E9f\u00E9rences : ",
            dossier.dossierNumber),
        dateLimit && React.createElement("p", { className: 'font-size-12 text-white mb-0' },
            "Date limite de r\u00E9ponse : ",
            dateLimit)));
};
